// Cache.match()/Cache.put() resolve string keys as URLs relative to the
// current document location. In a single-page app, the same logical key
// (e.g. "order_detail/20260610/ADRO.parquet") can resolve to a different
// absolute URL depending on the current route, causing spurious cache
// misses. Anchoring every key to a fixed path under location.origin keeps
// the resolved URL stable regardless of the current route.
export function blobCacheKey(path: string): string {
  return `${window.location.origin}/__blob-cache__/${path}`;
}
